import { Dispatch, forwardRef, ForwardRefRenderFunction, SetStateAction } from 'react'
import { SwitchStyled } from './styles'

export interface SwitchStyledProps {
  width?: number
  height?: number
  padding?: number | string
  margin?: number | string
  paddingleft?: number | string
  switchsize?: number
  borderradius?: number
  transitionduration?: string
}

export interface ToggleProps {
  value: boolean
  setValue: Dispatch<SetStateAction<boolean | string>>
  processChange: () => void
  disabled?: boolean
  width?: number
  height?: number
  padding?: number | string
  margin?: number | string
  paddingleft?: number | string
  switchsize?: number
  borderradius?: number
  transitionduration?: string
  id?: string
  size?: 'small'
}

const ToggleComponent: ForwardRefRenderFunction<HTMLInputElement, ToggleProps> = (
  {
    value,
    setValue,
    width = 45,
    height = 25,
    padding = 0,
    margin = 2,
    paddingleft = 1,
    switchsize = 20,
    borderradius = 12,
    transitionduration = '200ms',
    processChange,
    disabled = false,
    id,
    size
  },
  ref
) => {
  const handleChange = () => {
    setValue(!value)
    processChange()
  }
  return (
    <>
      <SwitchStyled
        inputRef={ref}
        width={size ? 30 : width}
        height={size ? 20 : height}
        padding={padding}
        margin={margin}
        size={size}
        paddingleft={size ? -12 : paddingleft}
        switchsize={switchsize}
        borderradius={borderradius}
        transitionduration={transitionduration}
        focusVisibleClassName=".Mui-focusVisible"
        id={id}
        disableRipple
        disabled={disabled}
        checked={value}
        value={value}
        onChange={handleChange}
      />
    </>
  )
}

export const Toggle = forwardRef(ToggleComponent)
